import React, { Component } from 'react';

class RelaxingVibesPrivacyPolicy extends Component {
  render() {

    return (
        <section id="portfolio">
            <div class="row">
                <div class="two columns header-col">
                    <img class="s-about__pic" src="images/icon_st.png" alt="" />
                </div>
                <div class="ten columns flex-container">
                    <h1><span>Privacy Policy</span></h1>
                    <ul class="slides">
                        <p>Relaxing Vibes ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application ("App"). By using our App, you agree to the collection and use of information in accordance with this policy.</p>

                        <h2>1. Information Collection</h2>

                        <p>We collect the following types of information:

                        Personal Data: When you use our App, we may ask you to provide certain personally identifiable information, such as your name, email address, and phone number.

                        Usage Data: We may collect information on how the App is accessed and used, including data such as your device's Internet Protocol address, browser type, and usage patterns.

                        Tracking Data: We use cookies and similar tracking technologies to monitor activity in our App and hold certain information.</p>

                        <h2>2. Use of Data</h2>

                        <p>We use the collected data for various purposes, including:

                        Providing and maintaining our App:

                        Notifying you about changes to our App

                        Allowing you to participate in interactive features

                        Providing customer support

                        Monitoring usage to improve our App

                        Detecting and preventing technical issues</p>

                        <h2>3. Data Sharing</h2>

                        <p>We do not sell or rent your personal data. However, we may share your information with:

                        Service Providers: Third-party companies that assist in operating our App and providing services.

                        Legal Requirements: If required by law, we may disclose your personal data to comply with legal obligations.</p>

                        <h2>4. Data Security</h2>

                        <p>We implement reasonable security measures to protect your personal data. However, please be aware that no method of transmission over the internet is 100% secure.</p>

                        <h2>5. Your Data Protection Rights</h2>

                        <p>Depending on your location, you may have the right to:

                        Access the personal data we hold about you

                        Request corrections to inaccurate data

                        Object to or restrict processing of your data

                        Request deletion of your personal data</p>

                        <h2>6. Changes to This Privacy Policy</h2>

                        <p>We may update our Privacy Policy periodically. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy regularly.</p>
                                                
                        <p>This policy is effective as of 2025-04-04</p>
                    </ul>
                </div>
            </div>
       </section>
    );
  }
}

export default RelaxingVibesPrivacyPolicy;
